import styled from 'styled-components';
import { Card } from '@/components/card';
import { maybe } from '@/features/details/utils';
import { breakpoints } from '@/components/responsive';

export const Chip = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${(props: any) => (props.$mw ? `min-width: ${props.$mw};` : ``)}
  cursor: pointer;
  background: ${(props: any) => (props.whiteBg ? `white` : `transparent`)};
  font-size: 1.2rem;
  font-weight: 500;
  font-family: ${(props: any) =>
    props.whiteBg ? `'Inter', sans-serif` : `'JetBrains Mono', serif`};
  user-select: none;
  :hover {
    opacity: 0.5;
    box-shadow: ${(props: any) =>
      props.whiteBg ? `rgba(0, 0, 0, 0.08) 0px 1px 6px` : `none`};
  }
  :active {
    opacity: 1;
  }

  color: ${(props: any) => (props.whiteBg ? `#434d56` : `#545454`)};

  border: ${(props: any) =>
    props.whiteBg ? `none` : `1px solid rgba(0, 0, 0, 0.2)`};

  box-shadow: ${(props: any) =>
    props.whiteBg
      ? `rgba(0, 0, 0, 0.08) 0px 1px 6px`
      : `0 1px 4px 0 rgba(68, 72, 80, 0.08)`};

  border-radius: 2rem;
  padding: 0.6rem 1.5rem;
`;

export const DetailsCard = styled(Card)`
  && {
    cursor: default;
    display: grid;
    grid-row-gap: 2.5rem;
    padding: 3.5rem;
    border-radius: 2rem;

    ${breakpoints.down(`md`)} {
      width: 90%;
      margin: 0 auto;
      padding: 2rem;
      border-radius: 0.8rem;
    }
  }
`;
export const CONTROL = `CONTROL`;
export const DELETED = `deleted`;

export function getMetricsStartDate() {
  return maybe(
    () => new Date(new URL(window.location.href).searchParams.get(`s`)),
  );
}
